import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <img src="/logo.png" alt="FitMind AI" className="footer__logo" />
            <p className="footer__tagline">
              AI-powered fitness coaching that adapts to you — not the other way around.
            </p>
            <div className="footer__socials">
              <a href="https://www.instagram.com/fitmindai0/" aria-label="Instagram" className="footer__social">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
              <a href="https://www.tiktok.com/@fitmindai0" aria-label="TikTok" className="footer__social">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34l-.04-8.67a8.22 8.22 0 0 0 4.8 1.53V4.72a4.85 4.85 0 0 1-1-.03z"/>
                </svg>
              </a>
              {/*<a href="#" aria-label="YouTube" className="footer__social">*/}
              {/*  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">*/}
              {/*    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.4a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>*/}
              {/*    <polygon fill="#111" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>*/}
              {/*  </svg>*/}
              {/*</a>*/}
            </div>
          </div>

          <div className="footer__links-group">
            <h4>Product</h4>
            <ul>
              <li><a href="#features">Features</a></li>
              <li><a href="#how-it-works">How It Works</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#screenshots">App Preview</a></li>
            </ul>
          </div>

          <div className="footer__links-group">
            <h4>Company</h4>
            <ul>
              <li><a href="mailto:fitmindai@gmail.com">Contact Us</a></li>
              <li><a href="https://www.instagram.com/fitmindai0/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href="https://www.tiktok.com/@fitmindai0" target="_blank" rel="noopener noreferrer">TikTok</a></li>
            </ul>
          </div>

          <div className="footer__links-group">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {year} FitMind AI. All rights reserved.</p>
          <p className="footer__made">Made with ❤️ for fitness enthusiasts everywhere</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
